let store = require("../store");
let actions = require("../actions");

let Table = mc.widgets.Table;
let IconButton = mc.widgets.IconButton;

let UserFormView = require("./UserFormView");

class UserListView extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
  }

  getInitialState() {
    let { users, prefs } = store.getState();

    return {
      users,
      prefs
    };
  }

  componentDidMount() {
    this.unsubscribe = store.subscribe(this.handleStoreChange.bind(this));

    actions.loadUsers(store.getState().accountId);
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  handleStoreChange() {
    this.setState(this.getInitialState());
  }

  createUser() {
    UserFormView.open(null, this.onSaveUser);
  }

  editUser(user) {
    UserFormView.open(user, this.onSaveUser);
  }

  onSaveUser() {
    actions.loadUsers(store.getState().accountId);
  }

  sortUsers(key, direction) {
    actions.setPrefs({
      "userListSortKey": key,
      "userListSortDirection": direction
    });
  }

  render() {
    let { users, prefs } = this.state;

    let sortKey = prefs.userListSortKey || "name";
    let sortDirection = prefs.userListSortDirection || 1;

    let cols = [
      {
        prop: "name",
        label: tx("name"),
        content: (function (user) {
          let name = mc.format.name(user);

          if (user.isDisabled) {
            return <span data-disabled="true">{name}</span>;
          }

          return <a onClick={this.editUser.bind(this, user)}>{name}</a>;
        }).bind(this),
        width: "25%",
        sort: function (a, b) {
          let str = (n) => (n.firstName + n.lastName).toLowerCase();

          return str(a) > str(b) ? 1 : -1;
        }
      },
      {
        prop: "email",
        label: tx("email_address"),
        content: function (user) {
          return user.email;
        },
        width: "30%",
        sort: true
      },
      {
        prop: "locale",
        label: tx("email_language"),
        content: function (user) {
          return user.locale.toLowerCase() === "ja_jp" ? "日本人" : "English";
        },
        width: "17.5%",
        sort: true
      },
      {
        prop: "createdTs",
        label: tx("created"),
        content: function (user) {
          return mc.format.date(user.createdTs);
        },
        width: "15%",
        sort: true
      },
      {
        prop: "disabledTs",
        label: tx("deleted"),
        content: function (user) {
          return user.disabledTs ? mc.format.date(user.disabledTs) : "–";
        },
        width: "12.5%",
        sort: true
      }
    ];

    return (
      <div className="rc-user-list-view">
        <div className="mc-split-layout">
          <h1>{tx("users")}</h1>
          <IconButton icon="plus" scale={1.2} label={tx("new_user")} onPress={this.createUser.bind(this)}/>
        </div>
        <div className="mc-card">
          <Table
            data={users}
            cols={cols}
            sort={sortKey}
            direction={sortDirection}
            onSort={this.sortUsers.bind(this)}/>
        </div>
      </div>
    );
  }
}

module.exports = UserListView;
